import { LitElement, html, css } from 'lit';
import { msg,str } from '@lit/localize';
import { accessibility,formStyles,dialog,details,grid } from '../../utilities/styles';
import { validateForm, decodeEntities, checkFormLock, releaseFormLock, lockForm, validateURL, releaseFormLockwithBeacon, hideRevealInputs } from '../../utilities/formsUtilities';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { AllInOrganisationConsumer } from '../Utilities/AllInOrganisationConsumer';
import { eyeSvg, deleteIcon,expandIcon, collapseIcon } from '../../utilities/icons';
import { hideRevealPassword } from '../../utilities/formsUtilities';
import { AllInSessionStorage } from '../Utilities/AllInSessionStorage';
import { AllInIntegrationsBase } from '../Utilities/AllInIntegrationsBase';
import { handle403s } from '../../utilities/AllInErrorHandling';

export class AllInIntegrationForm extends AllInIntegrationsBase(AllInSessionStorage(AllInOrganisationConsumer(LitElement))) {
    static properties = {
        _isFormLocked: {state:true,type:Boolean},
        _formHasValues: {state:true,type:Boolean},
        _usesActionLinks: {state:true,type:Boolean},
        loading: {state:true,type:Boolean},
        success: {state:true,type:Boolean},
    }

    constructor() {
        super();
    }

    get _form(){
        return this.shadowRoot.querySelector('form');
    }

    async connectedCallback() {
        super.connectedCallback();
        if(this.providerConfig){
            this.formID = `organisation_integration_${this.currentOrg}`;
        }
        this.uid = `integration-form-${this.organisationData.user.id}`;
        this.renderRoot.querySelector('a')?.focus();
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        this.eventManager.disconnect();
        releaseFormLock(this.formID,this.uid,this.restUrl,this.nonce);
    }

    async firstUpdated(){
        if(this.formID){
            this._isFormLocked = await checkFormLock(this.formID,this.uid,this.restUrl,this.nonce);
            addEventListener('visibilitychange', (event) => {
                if (document.visibilityState === 'hidden') {
                    releaseFormLockwithBeacon(this.formID, this.uid, this.restUrl, this.nonce);
                } 
            });

        }

    }

    updated(changedProperties) {
        if(this._form){
            hideRevealInputs(this._form);
        }
    }

    /* <button id="zone" class="btn change_view ${this.view=='zone'?'active':''}" disabled aria-pressed="${this.view=='zone'?'true':'false'}">
        ${msg('Manage zones. Coming soon')}
    </button>  */
    render() {
        let main='';
       
        if(this.loading){
            main = html`<allin-loader loading></allin-loader>`;
        }
        else{
            if(this.providerConfig&&this._isFormLocked){
                main = html`
                    <h3>${msg('Ticketing provider integration')}</h3>
                    <div class="bg">
                        <div class="message notice" aria-live="polite">
                            <p>${msg('This form is currently being edited by another member of this organisation')}</p>
                        </div>
                    </div>
                `;
            } 
            if(this.success){
                let _hasConfig = Object.keys(this.providerConfig ?? {}).length > 0;
                let memberDisabled=false;
                let memberText = '';
                if(this.providerConfig?.provider=='TicketsolveJSON'||this.providerConfig?.provider=='TicketsolveXML'){
                    memberDisabled=true;
                    memberText = msg('Your current ticketing provider does not support member data integration.');
                }
                else if(this.providerConfig?.provider=='DMS'||this.providerConfig?.usesActionLinks){
                    memberDisabled=true;
                    memberText = msg('You are using Action Links for your Membership Integration.');
                }
                else{
                    
                    memberText = _hasConfig?
                    html`<a href="javascript:void(0)" class="card_target" @click=${(e)=>this._showPanel('member-configuration')}>${msg('Manage member data')}</a>`:
                    html`<p class="disabled_message">${msg('You need to configure your ticketing provider before you can manage member data')}</p>`;          
                    memberDisabled=!_hasConfig;
                }
                 let eventText = '';
                let eventDisabled = false;
                if(this._hasConfig){
                    if(this.providerConfig?.provider=='DMS'){
                        eventDisabled = true;
                        eventText = msg(`Your ticketing provider doesn't support event listing integration.`);
                    }
                    else{
                        eventText = html`<a href="javascript:void(0)" class="card_target" @click=${(e)=>this._showPanel('event-configuration')}>${msg('Manage event listing data')}</a>`;
                    }
                }
                else{
                    eventDisabled = true;
                    eventText = html`<p class="disabled_message">${msg('You need to configure your ticketing provider before you can manage event listing data')}</p>`
                }
                
                main = html`
                    <h3>${msg('Success')}</h3>
                    <div class="message notice" aria-live="polite">
                        <p>${msg('Success! You have connected your ticketing provider.')}</p>
                    </div>
                    <h3>${msg('Next steps')}</h3>    

                    <div class="grid grid_50">
                        <div class="bg inner-padding card ${eventDisabled?'disabled':''}">
                            <h3>${msg('Event listing integration')}</h3>
                            <p>${unsafeHTML(this.integration_panels?.integrations_event_listing_description_text)}</p>
                            ${eventText}
                        </div>
                        <div class="bg inner-padding card ${memberDisabled?'disabled':''}">
                            <h3>${msg('Member integration')}</h3>
                            <p>${unsafeHTML(this.integration_panels?.integrations_member_description_text)}</p>
                            ${memberText}
                        </div>
                    </div>
                `;
            }
            else{
                let form_elements = ``;
                if(this.providerConfig?.provider=='SpektrixV3'){
                   form_elements = html`
                    <div class="input-group">
                        <label for="baseUrl">${msg(`Spektrix Base URL`)}*</label>
                        <p class="small">${msg(`Example:`)} https://system.spektrix.com/{clientcode}/api/v3 or https://{your.custom.domain}/{clientcode}</p>  
                        <input type="url" id="baseUrl" name="baseUrl" data-label="${msg(`Spektrix Base URL`)}" data-table_label="${msg(`Spektrix Base URL`)}" aria-required="true" value="${this.providerConfig?.configuration?.baseUrl}" />
                    </div>
                    <div class="input-group">
                        <label for="host">${msg(`Spektrix Host`)}*</label>
                        <p class="small">${msg(`Example:`)} system.spektrix.com or {your.custom.domain}. No protocol needed.</p>
                        <input type="text" id="host" name="host" data-label="${msg(`Spektrix Host`)}" data-table_label="${msg(`Spektrix Host`)}" aria-required="true" value="${this.providerConfig?.configuration?.host}" />
                    </div>
                    <div class="input-group">
                        <label for="username">${msg(`Spektrix Username`)}*</label>
                        <input type="text" id="username" name="username" data-label="${msg(`Spektrix Username`)}" data-table_label="${msg(`Spektrix Username`)}" aria-required="true" value="${this.providerConfig?.configuration?.username}" />
                    </div>
                     <div class="input-group">
                        <label for="apiSecretKey">${msg(`Spektrix API Key`)}*</label>  
                        <div class="pword_wrapper">
                            <input type="password" id="apiSecretKey" name="apiSecretKey" data-label="${msg(`Spektrix API Key`)}" data-table_label="${msg(`Spektrix API Key`)}" aria-required="true" value="${this.providerConfig?.configuration?.apiSecretKey}">
                            <button data-switch="apiSecretKey" aria-label="${msg('Show API key',{desc:'button to show password in plain text'})}" aria-pressed="false" type="button" class="show-password" data-show="${msg('Show API key',{desc:'button to show password in plain text'})}" data-hide="${msg('Hide API key',{desc:'button to hide password'})}" @click=${hideRevealPassword}>
                            ${eyeSvg} ${msg('Show API key',{desc:'button to show password in plain text'})}</button>
                        </div>
                    </div>
                    <div class="input-group">
                        <label for="usesActionLinks">${msg(`Use Action Links`)}</label>
                        <input type="checkbox" name="usesActionLinks" id="usesActionLinks" data-label="${msg(`Use Action Links`)}" data-table_label="${msg(`Use Action Links`)}" @change=${(e)=>{this._handleUsesActionLinksChange(e);}} ?checked=${this._usesActionLinks||this.providerConfig?.usesActionLinks} />
                    </div>
                   ` 
                }
                else if(this.providerConfig?.provider=='TicketsolveJSON'||this.providerConfig?.provider=='TicketsolveXML'||this.providerConfig?.provider=='Ticketsolve'){
                    let url = '';
                    if(this.providerConfig?.provider=='TicketsolveJSON') url = this.providerConfig?.configuration?.baseUrl;
                    else url = this.providerConfig?.configuration?.url;
                    form_elements = html`
                    <div class="input-group">
                        <label for="feedtype">${msg(`Ticketsolve feed type`)}*</label>
                        ${this.integration_panels?.integrations_ticketsolve_description? html`<p class="small">${this.integration_panels?.integrations_ticketsolve_description}</p>` : ''}
                        <select id="feedtype" name="feedtype" data-label="${msg(`Ticketsolve feed type`)}" data-table_label="${msg(`Ticketsolve feed type`)}" aria-required="true" data-hider="ticketsolve-api-key" data-reveal="TicketsolveJSON">
                            <option value="TicketsolveXML" ?selected=${this.providerConfig?.provider=='TicketsolveXML'}>${msg(`XML`)}</option>
                            <option value="TicketsolveJSON" ?selected=${this.providerConfig?.provider=='TicketsolveJSON'}>${msg(`JSON`)}</option>
                        </select>
                    </div>
                    <div class="input-group hidden ticketsolve-api-key" >
                        <label for="apikey">${msg(`Ticketsolve API Key`)}*</label>
                        <input type="text" id="apikey" name="apikey" data-label="${msg(`Ticketsolve API Key`)}" data-table_label="${msg(`Ticketsolve API Key`)}" aria-required="true" value="${this.providerConfig?.configuration?.apiKey}" />
                    </div>
                    <div class="input-group">
                        <label for="url">${msg(`Ticketsolve URL`)}*</label>
                        <input type="url" id="url" name="url" data-label="${msg(`Ticketsolve URL`)}" data-table_label="${msg(`Ticketsolve URL`)}" aria-required="true" value="${url}" />
                    </div>
                     <div class="input-group">
                        <label for="usesActionLinks">${msg(`Use Action Links`)}</label>
                        <input type="checkbox" name="usesActionLinks" id="usesActionLinks" data-label="${msg(`Use Action Links`)}" data-table_label="${msg(`Use Action Links`)}" @change=${(e)=>{this._handleUsesActionLinksChange(e);}} ?checked=${this._usesActionLinks||this.providerConfig?.usesActionLinks} />
                    </div>
                    `
                }
                else if(this.providerConfig?.provider=='TessituraV15'){
                    //Add the following inputs: baseURl,username,password,group,location
                    form_elements = html`
                    <div class="input-group">
                        <label for="baseUrl">${msg(`Tessitura Base URL`)}*</label>
                        <input type="url" id="baseUrl" name="baseUrl" data-label="${msg(`Tessitura Base URL`)}" data-table_label="${msg(`Tessitura Base URL`)}" aria-required="true" value="${this.providerConfig?.configuration?.baseUrl}" />
                    </div>
                    <div class="input-group">
                        <label for="username">${msg(`Tessitura Username`)}*</label>
                        <input type="text" id="username" name="username" data-label="${msg(`Tessitura Username`)}" data-table_label="${msg(`Tessitura Username`)}" aria-required="true" value="${this.providerConfig?.configuration?.username}" />
                    </div>
                    <div class="input-group">
                        <label for="password">${msg(`Tessitura Password`)}*</label>
                        <div class="pword_wrapper">
                            <input type="password" id="password" name="password" data-label="${msg(`Tessitura Password`)}" data-table_label="${msg(`Tessitura Password`)}" aria-required="true" value="${this.providerConfig?.configuration?.password}" />
                            <button data-switch="password" aria-label="${msg('Show Tessitura password',{desc:'button to show password in plain text'})}" aria-pressed="false" type="button" class="show-password" data-show="${msg('Show Tessitura password',{desc:'button to show password in plain text'})}" data-hide="${msg('Hide Tessitura password',{desc:'button to hide password'})}" @click=${hideRevealPassword}>
                            ${eyeSvg} ${msg('Show Tessitura password',{desc:'button to show password in plain text'})}</button>
                        </div>
                    </div>
                    <div class="input-group">
                        <label for="group">${msg(`Tessitura Group`)}*</label>
                        <input type="text" id="group" name="group" data-label="${msg(`Tessitura Group`)}" data-table_label="${msg(`Tessitura Group`)}" aria-required="true" value="${this.providerConfig?.configuration?.group}" />
                    </div>
                    <div class="input-group">
                        <label for="location">${msg(`Tessitura Location`)}*</label>
                        <input type="text" id="location" name="location" data-label="${msg(`Tessitura Location`)}" data-table_label="${msg(`Tessitura Location`)}" aria-required="true" value="${this.providerConfig?.configuration?.location}" />
                    </div>
                    <div class="input-group">
                        <label for="constituentTypeId">${msg(`Tessitura Constituent Type ID`)}*</label>
                        <input type="text" id="constituentTypeId" name="constituentTypeId" data-label="${msg(`Tessitura Constituent Type ID`)}" data-table_label="${msg(`Tessitura Constituent Type ID`)}" aria-required="true" value="${this.providerConfig?.configuration?.constituentTypeId}" />
                    </div>
                    <div class="input-group">
                        <label for="originalSourceId">${msg(`Tessitura Original Source ID`)}*</label>
                        <input type="text" id="originalSourceId" name="originalSourceId" data-label="${msg(`Tessitura Original Source ID`)}" data-table_label="${msg(`Tessitura Original Source ID`)}" aria-required="true" value="${this.providerConfig?.configuration?.originalSourceId}" />
                    </div>
                    <div class="input-group">
                        <label for="businessUnitId">${msg(`Business Unit ID`)}*</label>
                        <input type="text" id="businessUnitId" name="businessUnitId" data-label="${msg(`Business Unit ID`)}" data-table_label="${msg(`Business Unit ID`)}" aria-required="true" value="${this.providerConfig?.configuration?.businessUnitId}" />
                    </div>
                    <div class="input-group">
                        <label for="usesActionLinks">${msg(`Use Action Links`)}</label>
                        <input type="checkbox" name="usesActionLinks" id="usesActionLinks" data-label="${msg(`Use Action Links`)}" data-table_label="${msg(`Use Action Links`)}" @change=${(e)=>{this._handleUsesActionLinksChange(e);}} ?checked=${this._usesActionLinks||this.providerConfig?.usesActionLinks} />
                    </div>
                    `
                }
                let actionLinksFormElements = ''; 
                if(this._usesActionLinks||this.providerConfig?.usesActionLinks){
                    actionLinksFormElements = html`
                        <div class="input-group">
                            <label for="actionLinksUrl">${msg(`Action Links URL`)}*</label>
                            <input type="text" id="actionLinksUrl" name="actionLinksUrl" data-label="${msg(`Action Links URL`)}" data-table_label="${msg(`Action Links URL`)}" aria-required="true" value="${this.providerConfig?.actionLinksUrl}" aria-required="true"/>
                        </div>
                    `;
                }
                main = html`
                    <div class="form_container">
                        ${this._eventsError?html`<div class="message error"><p>${this._eventsError}</p></div>`:''}
                        <p>${unsafeHTML(this.integration_panels?.integrations_event_listing_intro_text)}</p>
                        <h3>${this.providerConfig?msg(`Update your ticketing platform`) : msg(`Choose your ticketing platform`)}</h3>
                    
                        <div class="message notice" aria-live="polite">
                            ${this.message?html`<p>${this.message}</p>`: ''}
                        </div>
                        <form @submit=${this._handleSubmit}>
                            <div class="message notice" aria-live="polite">
                            </div>
                            <div class="bg">
                                <div class="input-group">
                                    <label for="provider">${this.providerConfig?.configuration?msg(`Update your ticketing platform`): msg(`Which platform do you want to connect with?`)}*</label>
                                    <p class="small"><a href="https://allin.zendesk.com">Can't find your ticketing platform? Chat with All In.</a></p>
                                    <select name="provider" id="provider" data-label="${msg(`Ticketing platform`)}" data-table_label="${msg(`Ticketing platform`)}" @change=${(e)=>{this._handleProviderChange(e);}}>
                                        <option value="">${msg(`Please select`)}</option>
                                        <option value="SpektrixV3" ?selected=${this.providerConfig?.provider=='SpektrixV3'}>Spektrix</option>
                                        <option value="Ticketsolve" ?selected=${this.providerConfig?.provider=='TicketsolveJSON'|| this.providerConfig?.provider=='Ticketsolve'|| this.providerConfig?.provider=='TicketsolveXML'}>Ticketsolve</option>
                                        <option value="TessituraV15" ?selected=${this.providerConfig?.provider=='TessituraV15'}>Tessitura</option>
                                        <option value="DMS" ?selected=${this.providerConfig?.provider=='DMS'}>Action Links only</option>
                                    </select>
                                </div>
                                <p><a href="https://allin.zendesk.com" target="_blank" rel="noopener noreferrer">${msg(`View support document on how to integrate your event data with All In.`)}</a></p>
                                <div aria-live="polite">
                                    ${form_elements}
                                </div>
                                
                                <div aria-live="polite">
                                    ${actionLinksFormElements}
                                </div>
                                <input type="hidden" name="org_id" value="${this.currentOrg}" />
                                <input type="hidden" name="action" value="add-provider" />
                                <div class="button-group">
                                    <button type="submit" ?disabled=${(!this.providerConfig?.provider||this.providerConfig?.provider=='DMS')&&!this.providerConfig?.usesActionLinks}>${msg(`Submit`)}</button>
                                </div>   
                                <hr>
                                <a href="javascript:void(0)" @click=${this._hidePanel}>${deleteIcon}${msg(`Cancel`)}</a>
                            </div>
                        </form>
                    </div>
                `;
            }
        }
        return html`${main}`;
    }

    _handleProviderChange(e){
        let provider = e.target.value;
        if(provider == 'DMS'){
            this._usesActionLinks = true;
        }
        this.providerConfig = {
            provider:provider,
            usesActionLinks: this._usesActionLinks || false
        };
    }

    _handleUsesActionLinksChange(e){
        this._usesActionLinks = e.target.checked;
        if(this.providerConfig){
            this.providerConfig.usesActionLinks = this._usesActionLinks;
        }
    }

    _handleClick(e){
        e.preventDefault();
        this.panel = '';
        this.view = '';
        let crumb = {
            organisation:{url:`/organisation-dashboard/${this.currentOrg}/`,title:msg(str`${this.organisation?.name} Dashboard`)},
            dashboard:{url:`/organisation-dashboard/${this.currentOrg}/`,title:msg(`Integrations`)}
        }
        this.eventManager.emit(`allin-breadcrumb-${this.name}`,crumb);
        this.eventManager.addHistory('/organisation-dashboard/'+this.currentOrg+'/integrations',{panel:'',view:''});
        this.eventManager.emit(`allin-organisation-${this.name}-switcher`,{dashboard:'integrations',panel:``,view:''});
        this.partial = false;
    }

    
    async _handleSubmit(e){
        e.preventDefault();
        let formResponse = this._form.querySelector('.message');
        formResponse.innerHTML = '';
        formResponse.classList.remove('error');
        let submitButton = this._form.querySelector('[type="submit"]');
        let valid = validateForm(this._form,formResponse);
        if(!valid){ 
            formResponse.scrollIntoView();
            return;
        }
        let formData = new FormData(this._form);
        //formData = JSON.stringify(Object.fromEntries(formData));
        this._form.classList.add('loading');
        submitButton.disabled = true;
        this._form.setAttribute('aria-busy', 'true');
        try{
            let response = await fetch(this.restUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'AllIn-Nonce': this.nonce,
                }
            })

            if(response.status === 403){
                handle403s();
                return;
            }

            response = await response.json();
            if(response.ok){
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                this.providerConfig = response.provider;
                this.success = true;
                this.organisation.integration_config = response.provider;
                this._updateContext({organisation:this.organisation, providerConfig:this.providerConfig, providerConfigMapping:response.provider?.mapping});
                submitButton.disabled = false; 
            }
            else{
                formResponse.innerHTML = response.message;
                formResponse.classList.add('error');
                this._form.classList.remove('loading');
                this._form.setAttribute('aria-busy', 'false');
                submitButton.disabled = false; 
            }
        }
        catch(error){
            console.error('Error:', error);
            formResponse.innerHTML = 'Something went wrong';
            formResponse.classList.add('error');
            this._form.classList.remove('loading');
            this._form.setAttribute('aria-busy', 'false');
        };
    }
    
   

    _getOrganisationById(id){
        return this.organisations.find((org)=>org.org_id==id);
    }

    _validateURL(e){
        if(e.target.type!=='url') return;
        validateURL(e.target);
    }

    _checkIfFormHasValues(e){
        let form = this._form;
        let selects = form.querySelectorAll('select');
        let hasValues = false;
        for(let i=0;i<selects.length;i++){
            let select = selects[i];
            if(select.id=='event_select') continue;
            if(select.value){
                if(select.id.startsWith('location_')){
                    this._handleLocationChange({target:select},select.id.replace('location_',''));
                }
                hasValues = true;
            }
        };
        this._formHasValues = hasValues;
    }



    static styles = [
        accessibility,
        formStyles,
        dialog,
        details,
        grid,
        css`
        allin-greeting{
            --allin-font-size: 2rem;
            --allin-font-weight: 700;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .bg a{
            font-size:0.9rem;
            text-decoration:none;
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            display:flex;
            align-items:center;
            gap:0.5rem;
        }

        .bg a:hover{
            text-decoration:underline;
        }



        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }

        .button-group{
            display:flex;
            justify-content:space-between;
            margin-top:2rem;
        }
        
       
        .border-top{
            border-top:1px solid var(--allin-highlight-color,#472961);
            padding-top:2rem;
        }
        .button-group button:not([type="submit"]), .return{
            background-color:transparent;
            color:var(--allin-highlight-color,#472961);
            border:0;
            display:flex;
            gap:0.5rem;
            align-items:center;
            text-decoration:underline;
            cursor:pointer;
            transition:color var(--transition) ease;
            font-weight:700;
            font-size:1rem;

        }
        .return{
            padding:0;
            margin-bottom:2rem;
        }

        .button-group button svg, .return svg{
            transition:transform var(--transition) ease;
        }
        .button-group button:hover, .return:hover{
            text-decoration-thickness:2px;
        }
        
        .button-group button:hover svg, .return:hover svg{
            transform:rotate(15deg);
        }
        @media (prefers-reduced-motion: reduce) {

            .button-group button:hover svg, .return:hover svg{
                transform:none;
            }
        }
        table{
            width:100%;
            border-collapse:collapse;
        }

        td{
            padding-bottom:2rem;
            word-break:break-all;
        }

        td:first-child:not(.duet-date__cell){
            width:42%;
            padding-right:2rem;
            vertical-align:top;
        }

        td:last-child{
            width:58%;
            font-weight:600;
            vertical-align:top;
        }
        
        td svg{
            height:0.5rem;
        }

        hr{
            border:0;
            border-top:1px solid var(--allin-highlight-color,#472961);
            margin-top:2rem;
            margin-bottom:2rem;
        }
        allin-image-uploader img[src='']{
            display:none;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }

        .collapse div{
            overflow:hidden;
            max-height:0;
            transition:max-height var(--transition) ease;
        }
        .collapse td{
            padding-bottom:0
            transition:all var(--transition) ease;
            border-bottom:1px solid transparent;
        }

        .collapse.open div{
            max-height:1000px;
        }

        .collapse.open td{
            padding-bottom:1rem;
            border-bottom-color:var(--allin-highlight-color,#472961);
        }

        .flex{
            display:flex;
            justify-content:space-between;
            align-items:center;
        }

        .flex button{
            background-color:transparent;
            border:0;
            cursor:pointer;
        }

        .buttons{
            display:flex;
            justify-content:flex-start;
            gap:1rem;
            margin-bottom:2rem;
        }

        .buttons button{
            background-color:#fff;
            color:var(--allin-highlight-color,#472961);
            border:1px solid var(--allin-highlight-color,#472961);
            padding:0.5rem 1rem;
            cursor:pointer;
            transition:background-color var(--transition) ease, color var(--transition) ease;
            font-size:1rem;
            font-weight: var(--allin-button-font-weight, 600);
        }

        .buttons button.active, .buttons button:hover{
                background-color: var(--color-secondary-lighter-to-primary-lighter, #d3c9d7);
                font-weight: var(--allin-button-font-weight, 600);
                color: #343434;
        }

        .buttons button.active{
            cursor:default;
        }

        td button svg:last-child{
            display:none;
        }

        td button svg:last-child path{
            fill:var(--allin-highlight-color,#472961);
        }

        td button[aria-expanded="true"] svg:first-child{
            display:none
        }
        
        td button[aria-expanded="true"] svg:last-child{
            display:inline-block;
        }

        .image_description img{
            object-fit:contain;
            object-position:top left;
        }

        .provision allin-tooltip {

            width: 100%;
            padding-left: 1.9rem;
            margin-top: 0.5rem;
        }

        .provision .hidden {
            display: none;
            max-height:0;
            overflow:hidden;
            transition:all var(--transition) ease;
            transition-behavior: allow-discrete;
            padding:0.5rem 1rem 0.5rem 1rem;
            width:100%;

        }

        .provision .hidden label textarea{
            margin-top:0.5rem;
        }

        .provision:has(>.hidden){
            border-bottom: 1px solid var(--allin-highlight-color,#472961);
            padding:1rem 0;
            margin:0 0 1rem;
        }
    
        .provision .input-group:has(:checked)~.hidden {
            display: block;
            max-height:700px;
            box-sizing: border-box;
            overflow:visible;
        }

        .provision {
            padding-bottom: 1rem;
            margin-bottom: 1rem;
            border-bottom: 2px solid var(--allin-highlight-color,#472961);
            gap:0.5rem;
        }

        .provision:last-child {
            border-bottom: none;
            margin-bottom: 0;
            padding-bottom: 0;
        }

        allin-image-uploader img {
            width: 100px;
            height: 100px;
            object-fit: contain;
            object-position: left;
        }
        allin-image-uploader img,allin-image-uploader input{
            margin:0.5rem 0;
        }

        .image-uploader:has(img[src='']){
            display:none;
        }
        .image-uploader ~ input[type='file']{
            display:none;
        }
        .image-uploader:has(img[src='']) ~ input[type='file']{
            display:block;
        }

        .image-uploader {
            display: flex;
            align-items: start;
            gap: 1rem;
        }
        
        .image-uploader button {
            background-color: transparent;
            margin-top: 0.5rem;
            padding: 0;
        }
        
        .image-uploader button svg path {
            fill: black;
        }

        allin-image-uploader{
            overflow:hidden;
        }
        allin-image-uploader ::file-selector-button{
            display:block;
            background-color:var(--allin-highlight-color,#472961);
            color:#fff; 
            padding:0.5rem 1rem;
            border:none;
            border-radius:0.5rem;
            cursor:pointer;
            text-align:center;
            font-size:1rem;
            font-weight:bold;
            transition:background-color var(--transition) ease;
            width:max-content;
        }

        allin-image-uploader ::file-selector-button:hover{
            background-color:var(--allin-highlight-color,#472961);
        }
        .add_uploader{
            background-color: var(--allin-button-bg-color, #472961);
            color: #fff;
            margin-bottom: 1.5rem;
        }
        .add_uploader span svg {
            background-color: #fff;
            transform: translate(0px, 3px);
        }

        .add_uploader:hover span svg {
            background-color: transparent;
        }
        
        allin-multiloader .group .button_secondary{
            background-color: transparent;
            color: var(--allin-button-bg-color, #472961);
            display:none
        }

        allin-multiloader .group:has(.image-uploader img[src=""]) .button_secondary{
            display: block;
        }

        .image-uploader ~ input[type='file']{
            background-color: transparent !important;
        }
        .grid--icon{
            grid-template-columns: 1.6rem 1fr;
            gap:1.5rem;
        }
        @media screen and (min-width:700px){
            .grid--image{
                grid-template-columns: 200px 1fr;
                gap:3rem;
            }
        }
        .item{
            margin-bottom:1rem;
            width:100%;
        }

        .item p{
            margin-bottom:0.2rem;
        }
        .provisions{
            background-color:#fff;
            border-radius:0.4rem;
            border:1px solid #707070;
            padding:0;
            margin-bottom:1rem;
                container-type: normal;
        }
        .provisions summary{
            padding:1rem 3rem 1rem 1rem;
            margin:0;
            font-size:1.25rem;
            font-size:clamp(1.25rem, 5cqw, 1.5rem);
            font-weight:700;
            color:var(--allin-highlight-color,#472961);
            cursor:pointer;
            display: grid;
            grid-template-columns: 1.5rem 1fr;
            align-items: center;
            gap: 1.5rem;
        }
        .provisions.no-image summary{
            grid-template-columns: 1fr;
        }
        .provisions summary::after{
            right:1rem;
            top:1.2rem;
        }
        .provisions .panel{
            padding:0.5rem 1rem;
        }
        input:read-only:not([type=submit]) {
            background-color: #fff;
        }
        .provisions img{
            object-fit:contain;
            object-position:top left;
        }
        .provisions summary img{
            object-fit:contain;
            object-position:top left;
            width:24px;
        }
        .collapsers{
            margin-left:auto;
            margin-bottom:1rem;
            display: flex;
            flex-wrap: wrap;
            gap: 1rem;
            width: fit-content;
        }
        .collapsers button{
            background-color: transparent;
            color: var(--allin-highlight-color,#472961);
            border: 0;
            cursor: pointer;
            font-weight: 700;
            font-size: 1rem;
            display: flex;
            align-items: center;
            gap: 0.5rem;
        }
         .listbox-area {
            
            padding: 20px;
            border: 1px solid #aaa;
            border-radius: 4px;
            background: #eee;
        }
        @media screen and (min-width:700px){
            .listbox-area {
                display: grid;
                grid-gap: 2em;
                grid-template-columns: repeat(2, 1fr);
            }
        }
        [role="listbox"] {
            margin: 1em 0 0;
            padding: 0;
            min-height: 18em;
            border: 1px solid #aaa;
            background: white;
        }

        [role="listbox"]#ss_elem_list {
            position: relative;
            max-height: 18em;
            overflow-y: auto;
        }

        [role="listbox"] + *,
        .listbox-label + * {
            margin-top: 1em;
        }

        [role="group"] {
            margin: 0;
            padding: 0;
        }

        [role="group"] > [role="presentation"] {
            display: block;
            margin: 0;
            padding: 0 0.5em;
            font-weight: bold;
            line-height: 2;
            background-color: #ccc;
        }

        [role="option"] {
            position: relative;
            display: block;
            margin: 2px;
            padding: 2px 1em 2px 1.5em;
            line-height: 1.8em;
            cursor: pointer;
        }

        [role="listbox"]:focus [role="option"].focused {
            background: #bde4ff;
        }

        [role="listbox"]:focus [role="option"].focused,
        [role="option"]:hover {
            outline: 2px solid currentcolor;
        }

        .move-right-btn span.checkmark::after {
            content: " →";
        }

        .move-left-btn span.checkmark::before {
            content: "← ";
        }

        [role="option"][aria-selected="true"] span.checkmark::before {
            position: absolute;
            left: 0.5em;
            content: "✓";
        }

        button[aria-haspopup="listbox"] {
            position: relative;
            padding: 5px 10px;
            width: 150px;
            border-radius: 0;
            text-align: left;
        }

        button[aria-haspopup="listbox"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top-color: currentcolor;
            border-bottom: 0;
            content: "";
        }

        button[aria-haspopup="listbox"][aria-expanded="true"]::after {
            position: absolute;
            right: 5px;
            top: 10px;
            width: 0;
            height: 0;
            border: 8px solid transparent;
            border-top: 0;
            border-bottom-color: currentcolor;
            content: "";
        }

        button[aria-haspopup="listbox"] + [role="listbox"] {
            position: absolute;
            margin: 0;
            width: 9.5em;
            max-height: 10em;
            border-top: 0;
            overflow-y: auto;
        }

        [role="toolbar"] {
            display: flex;
        }

        [role="toolbar"] > * {
            border: 1px solid #aaa;
            background: #ccc;
        }

        [role="toolbar"] > [aria-disabled="false"]:focus {
            background-color: #eee;
        }

        button {
            font-size: inherit;
        }

        button[aria-disabled="true"] {
            opacity: 0.5;
        }

        .annotate {
            color: #366ed4;
            font-style: italic;
        }

        .hidden {
            display: none;
        }

        .offscreen {
            position: absolute;
            width: 1px;
            height: 1px;
            overflow: hidden;
            clip: rect(1px 1px 1px 1px);
            clip: rect(1px, 1px, 1px, 1px);
            font-size: 14px;
            white-space: nowrap;
        }
        @media screen and (min-width:700){
            allin-multiloader .input-group{
                display:grid;
                grid-template-columns: 1fr 2fr;
                grid-template-rows: auto auto auto;
                column-gap:2rem;
                margin-bottom:2rem;
            }
        }
        allin-multiloader .group{
            display:none;
        }

        allin-multiloader .group.show{
            display:block;
        }
        allin-multiloader .input-group allin-image-uploader{
            grid-column: 1 / 2;
            grid-row: 1 / -1;
        }

        allin-multiloader allin-image-uploader .image-uploader{
            display:block;

        }

        allin-multiloader allin-image-uploader .image-uploader button{
            background-color: #fff;
            border-radius: 0.5rem;
            padding: 0.5rem 1rem;
            border: 1px solid var(--allin-highlight-color,#472961);
            color: var(--allin-highlight-color,#472961);
        }

        allin-multiloader allin-image-uploader .image-uploader button:hover{
            background-color: var(--allin-highlight-color,#472961);
            color: #fff;
        }

        .instances{
            padding:0;
            margin:0;
            list-style:none;
        }

        .instances li:not(:last-child){
            margin-bottom:1rem;
            padding-bottom:1rem;
            border-bottom:1px solid var(--allin-highlight-color,#472961);
        }
        
        .instances dl{
            display:grid;
            grid-template-columns: max-content 1fr;
            gap:1rem;
        }
         @media screen and (min-width:700px){
            .instances dl{
                display:grid;
                grid-template-columns: max-content 1fr;
                gap:1rem;
            }
         }

        .instances dl dt{
            font-weight:500;
        }
        
        dd h4{
            margin:0 0 0.5rem 0;
        }

        dd p{
            margin-bottom:1rem;
        }
        p:has(+.provisions){
            grid-column: 1 / -1;
            margin-top:2rem;
            margin-bottom:0;
        }
        .repeater{
            padding:0 2rem;
        }

        .card.disabled{
            background-color:  #e1e1e1;
            pointer-events: none;
            color: #555;
        }

        .disabled_message{
            font-style:italic;
            color:var(--allin-highlight-color,#472961);
        }
        .grid {
            gap: 1.5rem;
        }

        .card a{
            display:block;
            padding:1rem;
            border-radius:var(--allin-border-radius,0.5rem);
            background-color:var(--allin-highlight-color,#472961);
            color:#fff;
            text-align:center;
            font-weight:700;
            text-decoration:none;
            transition:background-color var(--transition) ease;
            height:fit-content;
            align-self:end;
        }

        .card:hover a{
            background-color:var(--allin-highlight-color-lighter,#5e3e7d);
        }

        @media (min-width: 700px) {
            .show-password {
                top: calc(100% + 0.5rem)!important;
            }
        }
        .form_container{
            margin-top:2rem;
        }
        `
        ];
        
}